const searchFormLocation = {
  '/trucks': 'sale',
  '/trucks/rent': 'rent',
  '/trucks/proposals-purchase': 'proposals-purchase',
  '/trucks/proposals-rent': 'proposals-rent',
};

export default searchFormLocation;
